import { AnnouncementStatistics, CalendarEventStatistics, NewsletterStatistics, PostStatistics } from "./GraphQL";

export const defaultAnnouncementStatistics: AnnouncementStatistics = {
	count: 0,
	views: 0,
	reactions: 0,
};

export const defaultNewsletterStatistics: NewsletterStatistics = {
	count: 0,
	views: 0,
	reactions: 0,
	comments: 0,
};

export const defaultPostStatistics: PostStatistics = {
	count: 0,
	views: 0,
	reactions: 0,
	comments: 0,
};

export const defaultCalendarEventStatistics: CalendarEventStatistics = {
	count: 0,
	responsesAttending: 0,
	responsesNotAttending: 0,
	responsesMaybeAttending: 0,
};
